// // Development
export const ApiConnection = {
  // Development
  BACKEND_URL: "https://dev-global-marketplace.azurewebsites.net/",
  // Stage---
  // BACKEND_URL: "https://stag-global-marketplace.azurewebsites.net/",
  // Local backend (Platform Fee toggle testing)
  // BACKEND_URL: "http://localhost:5100/",
  //  Rajesh Backend
  // BACKEND_URL: "http://192.168.2.74:5000/",
  //  Piyush
  // BACKEND_URL: 'http://192.168.2.119:5000/',
  // BACKEND_URL: "http://172.20.10.3:5000/",
  TERM_AND_CONDITION: "https://dev-global-marketplace.azurewebsites.net/",
  PRIVACY_POLICY: "https://stag-global-marketplace.azurewebsites.net/",

} 
